export const CAREER_NAV_LINKS = [
  { name: 'About', url: '/career/about-us' },
  { name: 'Why Join', url: '/career/why-us' },
  { name: 'Jobs', url: '/career/jobs' },
  { name: 'Contact Us', url: '/career/contact-us' },
]

export function isCareerSubPath(path) {
  return typeof path === 'string' && path.startsWith('/career/')
}
